module.exports = __webpack_public_path__ + "static/media/b-img-4.7d26be71.png";